import service from '@/utils/request'

// 帖子列表
export function tieziliebiao(data) {
    return service({
        url: '/service/admin/post_list',
        method: 'post',
        data
    })
}
// 开启人工审核
export function postsetstatus(data) {
    return service({
        url: '/service/admin/post_setstatus',
        method: 'post',
        data
    })
}
// 人工审核状态查看
export function postStatusview(data) {
    return service({
        url: '/service/admin/post_statusview',
        method: 'post',
        data
    })
}
// 帖子审核操作
export function postSetverifystatus(data) {
    return service({
        url: '/service/admin/post_setverifystatus',
        method: 'post',
        data
    })
}
// 帖子详情
export function postView(data) {
    return service({
        url: '/service/admin/post_view',
        method: 'post',
        data
    })
}
// 置顶记录
export function postIstoprecord(data) {
    return service({
        url: '/service/admin/post_istoprecord',
        method: 'post',
        data
    })
}
// 帖子上下架
export function postSetstatusval(data) {
    return service({
        url: '/service/admin/post_setstatusval',
        method: 'post',
        data
    })
}
// 活动--选择发布人
export function actBusinessassociationlist(data) {
    return service({
        url: '/service/admin/act_businessassociationlist',
        method: 'post',
        data
    })
}
// 活动--添加
export function addAct(data) {
    return service({
        url: '/service/admin/actAdd',
        method: 'post',
        data
    })
}
// 活动--列表
export function actList(data) {
    return service({
        url: '/service/admin/actList',
        method: 'post',
        data
    })
}
// 活动--列表
export function policyList(data) {
    return service({
        url: '/service/admin/policy_list',
        method: 'post',
        data
    })
}
// 活动--详情
export function actview(data) {
    return service({
        url: '/service/admin/actElem',
        method: 'post',
        data
    })
}
// 政策--添加
export function addPolic(data) {
    return service({
        url: '/service/admin/add_policy',
        method: 'post',
        data
    })
}
// 政策--详情
export function viewPolicy(data) {
    return service({
        url: '/service/admin/view_policy',
        method: 'post',
        data
    })
}
// 政策--详情
export function editPolicy(data) {
    return service({
        url: '/service/admin/edit_policy',
        method: 'post',
        data
    })
}
// 政策--shanchu
export function delPolicy(data) {
    return service({
        url: '/service/admin/del_policy',
        method: 'post',
        data
    })
}
// 政策--act_update
export function actUpdate(data) {
    return service({
        url: '/service/admin/actEdit',
        method: 'post',
        data
    })
}
// 活动--报名列表
export function actEnrolllist(data) {
    return service({
        url: '/service/admin/act_enrolllist',
        method: 'post',
        data
    })
}
// 活动--报名列表
export function actReview(data) {
    return service({
        url: '/service/admin/act_review',
        method: 'post',
        data
    })
}

export function actSubmitreview(data) {
    return service({
        url: '/service/admin/act_submitreview',
        method: 'post',
        data
    })
}

//
// 活动--回顾修改
export function actSetstatusval(data) {
    return service({
        url: '/service/admin/act_setstatusval',
        method: 'post',
        data
    })
}
export function businessassociationDel(data) {
    return service({
        url: '/service/admin/actDelete',
        method: 'post',
        data
    })
}
export function postDel(data) {
    return service({
        url: '/service/admin/post_del',
        method: 'post',
        data
    })
}

//活动审核，用于管理员端
export function huoDongSetstatusval(data) {
    return service({
        url: '/service/admin/act_setstatusval',
        method: 'post',
        data
    })
}


/** 活动复制*/
export function activityCopy(data) {
  return service({
    url: "/service/admin/actCopy",
    method: "post",
    data,
  });
}
